import React, { Fragment, PureComponent, Children } from 'react'
import classNames from 'classnames'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import isEqual from 'lodash/isEqual'
import PropTypes from 'prop-types'
import { Button, Modal } from 'reactstrap'
import { connect } from 'react-redux'

// Libs
import { setStatePromise } from '../libs/utils'

// Comp
import HelpCenter from '../components/HelpCenter';

class ModalContainer extends PureComponent {
  static propTypes = {
    color: PropTypes.string.isRequired,
    colored: PropTypes.bool,
    header: PropTypes.bool,
    hideButton: PropTypes.bool,
    identifierClass: PropTypes.string,
    hooks: PropTypes.shape({
      onCancel: PropTypes.func,
      onClose: PropTypes.func,
      onOk: PropTypes.func,
      onOpen: PropTypes.func,
      postToggle: PropTypes.func,
      preToggle: PropTypes.func
    }),
    image: PropTypes.bool,
    children: PropTypes.any,
    themeName: PropTypes.any,
    title: PropTypes.any,
    helpCenterlink: PropTypes.any,
    blockPerm: PropTypes.any,
    normalBtnText: PropTypes.any,
    CustomBtn: PropTypes.any,
    backdrop: PropTypes.any,
    visible: PropTypes.any,
  } // END propTypes

  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

  } // END constructor


  componentDidMount() {
    this.setState({ modal: get(this, 'props.visible', false) });

  } // END componentDidMount


  componentDidUpdate(_prevProps, prevState){
    const
      visible     = get(this, 'props.visible'),
      prevVisible = get(prevState, 'visible');

    if (!isEqual(visible, prevVisible)) this.setState({ modal: !!visible });

  } // END componentDidUpdate


  /* /////////////// Binded methods /////////////// */
  toggle = confirmation => {
    if (confirmation !== 'ok' && confirmation === 'cancel') confirmation = 'cancel';
    const
      { preToggle, postToggle, onOpen, onClose, onOk, onCancel } = get(this, 'props.hooks', {}),
      { modal } = this.state;

      if (typeof preToggle === 'function') preToggle(confirmation);

      return setStatePromise(this, { modal: !this.state.modal })
        .then(() => {
          if (!modal && typeof onOpen === 'function')  onOpen(confirmation)
          else if (typeof onClose === 'function')     onClose(confirmation);

          if (confirmation === 'ok'     && typeof onOk === 'function')     onOk(confirmation);
          if (confirmation === 'cancel' && typeof onCancel === 'function') onCancel(confirmation);

          if (typeof postToggle === 'function') postToggle(confirmation);

        }); // END setStatePromise

  } // END toggle



  /* /////////////// Render /////////////// */
  render() {
    const { children, themeName, title, helpCenterlink, blockPerm, image } = this.props;
    const { color, colored, header, normalBtnText, CustomBtn, identifierClass, hideButton, backdrop } = this.props;

    const elementClassNames = classNames({
      'modal__container': true,
      [themeName]: !!themeName,
      [identifierClass]: !!identifierClass,
      [`collectionReminderForm modal-dialog--${ this.props.color }`]: !!color,
      'modal-dialog--colored': !!colored,
      'modal-dialog--header': !!header

    }); // END elementClassNames

    const bodyClassNames = classNames({
      'modal__body': true,
      'modal-image': !!image
    })

    let Icon = null;
    switch (this.props.color) {
      case 'primary':
        Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
        break;
      case 'success':
        Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
        break;
      case 'warning':
        Icon = <span className='lnr lnr-flag modal__title-icon'/>;
        break;
      case 'danger':
        Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
        break;
      default:
        break;

    } // END switch

    // Pass props to children
    const childrenWithProps = Children.map(children, child => React.cloneElement(child, {
      modal: { toggle: this.toggle, color, colored, header, normalBtnText, open: this.props.visible || this.state.modal },
      color: color,
      colored: colored,
      header: header

    }));

    return (
      <Fragment>
        {
          CustomBtn &&
          <div onClick={ blockPerm ? () => null : this.toggle }>{ CustomBtn }</div>
        }

        {
          (!hideButton && !isNil(hideButton)) && (<Button className='invoice__card__btn rounded btn btn-outline-secondary' color={ this.props.color } onClick={ this.toggle } outline> { this.props.normalBtnText }</Button>)
        }

        <Fragment>
          <Modal
            isOpen={ this.state.modal }
            toggle={ this.toggle }
            className={ elementClassNames }
            backdrop={ backdrop }
            contentClassName={ image ? 'modal-image' : ''}
          >

            { this.props.header && <div className='modal__header'>
              <span className='lnr lnr-cross modal__close-btn' onClick={() => this.toggle('cancel') }/>
              { this.props.header ? '' : Icon }
              <h3 className='bold-text modal__title'>
                { this.props.title }
                {
                 (title === 'INTEGRACIÓN CON SAT' || title === 'Integración con SPEI' || title === 'Integración con Stripe' || title === 'Configura oxxo pay') &&
                 <HelpCenter modal helpCenterlink={ helpCenterlink }/>
                }
              </h3>
            </div> }

            <div className={ bodyClassNames }>
              { children && childrenWithProps }
            </div>

          </Modal>
        </Fragment>
      </Fragment>
    ); // END return

  } // END render

} // END ModalContainer

export default connect(state => ({
  themeName: get(state, 'theme.className'),
  modalContainer: get(state, 'modalContainer')

}))(ModalContainer);



// WEBPACK FOOTER //
// ./src/modals/ModalContainer.js